<template>
  <b-row>
    <b-col v-for="doc in docs" v-bind:key="doc._id" xs="12" md="6" lg="3">
      <b-card>
        <b-img
          v-if="doc.contentType == 'image/jpeg'"
          v-bind="mainProps"
          center
          v-bind:src="'data:image/jpeg;base64,'+doc.imgBase64"
          alt="Img Avatar"
          v-on:click="openImgNewTab(doc.imgBase64, doc._id)"
        ></b-img>
        <b-img
          v-else
          v-bind="mainProps"
          center
          v-on:click="openPdfNewTab(doc._id)"
          src="/img/pdf-avatar.png"
          alt="Pdf Avatar"
        ></b-img>
        <div v-if="!preventDelete" class="text-center" slot="footer">
          <b-button v-on:click="deleteDoc(doc._id)" variant="danger" class="btn-sm">ลบ</b-button>
        </div>
      </b-card>
    </b-col>
    <b-col v-if="docs && docs.length <= 0">
      <p>ยังไม่มีเอกสาร</p>
    </b-col>

    <b-modal
      scrollable
      :id="'doc-img-modal-' + docType"
      title="รูปภาพเอกสาร"
      hide-footer
      size="lg"
      centered
    >
      <b-img
        v-if="modalImgData"
        thumbnail
        v-bind="{ class: 'w-50' }"
        v-bind:src="'data:image/jpeg;base64,'+ modalImgData"
        center
      ></b-img>
      <div class="text-center mt-2">
        <a
          :href="'data:image/jpeg;base64,'+ modalImgData"
          :download="modalImgId + '.jpg'"
        >ดาวน์โหลดเอกสาร</a>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import HttpDoc from '../services/http/Doc'

export default {
  name: 'DocList',
  props: ['docType', 'preventDelete', 'refId'],
  data () {
    return {
      mainProps: { class: 'w-50' },
      docs: [],
      modalImgData: '',
      modalImgId: ''
    }
  },
  async mounted () {
    this.init()
    Window.Event.$on('reloadDoc-' + this.docType, this.init)
  },
  beforeDestroy () {
    Window.Event.$off('reloadDoc-' + this.docType)
  },
  methods: {
    async init () {
      var httpDoc = new HttpDoc(this.docType, this.refId)
      var docResponse = await httpDoc.getAllDoc()
      if (docResponse.code === 1) {
        this.docs = docResponse.data
        if (this.docs.length > 0 && this.docType == 'company-verify') {
          Window.Event.$emit('setHasVerifyDoc')
        }
      } else if (docResponse.code === 12008) {

      } else {
        alert('โปรดติดต่อผู้ดูแลระบบ')
      }
    },
    async deleteDoc (docId) {
      var httpDoc = new HttpDoc(this.docType, this.refId)
      var deleteResult = await httpDoc.deleteDoc(docId)
      if (deleteResult.code == 1) {
        this.init()
      }
    },
    openImgNewTab (data, id) {
      // var image = new Image();
      // image.src = "data:image/jpg;base64," + data
      this.modalImgData = data
      this.modalImgId = id
      // var w = window.open("")
      // w.document.write(image.outerHTML)
      this.$bvModal.show('doc-img-modal-' + this.docType)
    },
    async openPdfNewTab (docId) {
      var httpDoc = new HttpDoc(this.docType, this.refId)
      try {
        var pdf = await httpDoc.getPdfDoc(docId)
      } catch (error) {
        alert('ไม่พบเอกสาร')
        return
      }
      var fileURL = URL.createObjectURL(pdf)
      window.open(fileURL, '')
    }
  }
}
</script>
